import React from 'react';
import { ShieldCheck, Award, FileText } from 'lucide-react';
export function Insurance() {
  const cards = [{
    icon: FileText,
    title: 'Insurance Claim Help',
    copy: 'Get help with quote details, claim information and scheduling support.'
  }, {
    icon: ShieldCheck,
    title: 'OEM & OEE Glass Options',
    copy: 'Ask about available glass options based on your vehicle, insurance, availability, preference and budget.'
  }, {
    icon: Award,
    title: 'Lifetime Workmanship Warranty',
    copy: "Auto glass installation is backed by Kosin's lifetime vehicle glass workmanship warranty."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-164">
      <div className="max-w-7xl mx-auto" data-id="element-165">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-167">
            <span className="text-brand-red" data-id="element-168">Insurance Help</span>, Quality
            Glass &amp; Warranty Protection
          </h2>
          <p className="text-lg text-slate-600" data-id="element-169">
            Emergency vehicle glass damage is stressful. Kosin's Glass can help
            coordinate with most insurance companies, provide free auto glass
            estimates and explain your repair or replacement options clearly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-170">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 shadow-sm text-center" data-id="element-171">
              <div className="w-14 h-14 bg-brand-redLight rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-172">
                <card.icon className="w-7 h-7 text-brand-red" data-id="element-173" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-174">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-175">{card.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-176">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-177">
            Ask About Insurance Help
          </a>
        </div>
      </div>
    </section>;
}